import { useProductVariations } from "@/features/productVariations";
import useQuantity from "./useQuantity";
import useAddToCart from "./useAddToCart";
import type { Product } from "@/types/products";

//#region Type
export interface CartController {
  variations: ReturnType<typeof useProductVariations>;
  quantity: ReturnType<typeof useQuantity>;
  cart: ReturnType<typeof useAddToCart>;
}
//#endregion

const useCartController = ({ product }: { product: Product | null }): CartController => {
  const variations = useProductVariations(product);

  const quantity = useQuantity(variations.matchedVariation);

  const cart = useAddToCart({
    product,
    quantity: quantity.quantity,
    selectedTerms: variations.selectedTerms,
    matchedVariation: variations.matchedVariation,
    getMatchedVariationId: variations.getMatchedVariationId,
  });

  return {
    variations,
    quantity,
    cart,
  };
};

export default useCartController;
